import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

// C2 — WHERE IS IT NOW, one per component: on the truck · pulled → its FAS tag and where that part is · sold ·
// scrapped · damaged · missing · not checked yet. Read from the part the component became, else a person's rating.
const TONE = {
  on_truck: "bg-emerald-50 text-emerald-800 border-emerald-200",
  pulled: "bg-sky-50 text-sky-800 border-sky-200",
  sold: "bg-slate-100 text-slate-700 border-slate-300",
  scrapped: "bg-slate-100 text-slate-500 border-slate-300",
  damaged: "bg-red-50 text-[#B01E28] border-red-200",
  missing: "bg-amber-50 text-amber-800 border-amber-200",
  unknown: "bg-white text-slate-500 border-slate-200",
};
const WORD = { on_truck: "ON THE TRUCK", pulled: "PULLED", sold: "SOLD", scrapped: "SCRAPPED", damaged: "DAMAGED",
  missing: "MISSING", unknown: "NOT CHECKED YET" };

// THE ONE COUNT LINE for a truck's components — a component and the part it became counted once, by where it is now.
export const ComponentListLine = ({ list, anyBad, testid, big = false }) => {
  if (!list?.line) return null;
  return (
    <p data-testid={testid} className={`font-mono text-slate-500 ${big ? "text-sm" : "text-[11px]"}`}>
      {list.line}
      {anyBad ? <b className="text-[#B01E28]"> · known bad still sells as a core</b> : null}
    </p>
  );
};

export const ComponentWhere = ({ where, testid, big = false }) => {
  if (!where) return null;
  const line = where.part_id && where.tag
    ? <>{where.line.split(where.tag)[0]}<Link data-testid={`${testid}-part`} to={`/parts/${where.part_id}`} className="font-mono font-semibold underline decoration-dotted">{where.tag}</Link>{where.line.split(where.tag).slice(1).join(where.tag)}</>
    : where.line;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 flex-wrap ${big ? "text-sm" : "text-[11px]"}`}>
      <span data-testid={`${testid}-code`} className={`rounded border px-1.5 py-0.5 font-mono font-bold uppercase tracking-wide ${big ? "text-xs" : "text-[10px]"} ${TONE[where.code] || TONE.unknown}`}>
        <MapPin className="inline w-3 h-3 mr-0.5 -mt-0.5" />{WORD[where.code] || where.code}
      </span>
      <span className="text-slate-600">{line}</span>
    </span>
  );
};
